<template>
  <b-modal
    id="lm-suggestion-modal"
    ref="LmSuggestionModal"
    :title="title"
    :ok-title="$t('Ok')"
    ok-variant="primary"
    cancel-variant="secondary"
    :cancel-title="$t('Cancel') "
    @ok="ok"
    @cancel="cancel"
    @close="cancel"
    @hidden="cancel"
    >
    <div id="info-seccion" v-if="info" v-html="info"></div>
    <form
      id="form"
      novalidate
      class="position-relative"
      @submit.prevent
    >
      <LmTextArea
        :id="textAreaSetup.id"
        v-model="form.content"
        :v="customValidation"
        :label="$t(textAreaSetup.label)"
        :placeholder="$t(textAreaSetup.placeholder)"
        ref="lmTextArea"
      />
    </form>
  </b-modal>
</template>

<script>

import LmTextArea from '@/components/form/elements/LmTextArea'

export default {
  data () {
    return {
      form: {
        content: ''
      },
      validate: false,
      mustValidate: false,
      initialForm: {}
    }
  },
  props: {
    title: {
      type: String,
      default: 'Titulo'
    },
    info: {
      type: String,
      default: ''
    },
    textAreaSetup: {
      type: Object,
      default: () => {
        return {
          id: 'suggestion',
          label: 'suggestion',
          placeholder: 'suggestion'
        }
      }
    }
  },
  components: {
    LmTextArea
  },
  computed: {
    customValidation () {
      return {
        required: false,
        $error: !this.form.content && this.validate
      }
    }
  },
  methods: {
    lmShow () {
      this.$refs['LmSuggestionModal'].show()
      setTimeout(() => {
        this.$refs.lmTextArea.$refs.textarea.focus()
      }, 100)
      return new Promise((resolve, reject) => {
        this.$on('ok', () => {
          const sendContent = { ...this.form }
          resolve(sendContent)
        })
        this.$on('cancel', () => {
          // eslint-disable-next-line
          reject('cancel')
        })
      })
    },
    ok (bvModalEvt) {
      this.mustValidate = true
      this.validate = true
      if (this.customValidation.$error) {
        bvModalEvt.preventDefault()
      } else {
        this.$emit('ok', this.form)
      }
    },
    cancel () {
      this.mustValidate = false
      this.validate = false
      this.form = JSON.parse(this.initialForm)
      this.$emit('cancel')
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>
